import template from './usersActivities.html';
import './usersActivities.scss';

class UsersActivitiesController {
  constructor($element, $timeout) {
    'ngInject';

    [this.$element] = Array.from($element);
    this.$timeout = $timeout;
    this.startDate = null;
    this.endDate = null;

    this.calendarOptions = {
      mode: 'range',
      dateFormat: 'm-d-Y',
      maxDate: new Date(),
      onChange: (dates) => this._changeDates(dates),
    };

    this._elements = {
      scroller: null,
      list: null,
    };
    this._elementQueries = {
      scroller: '[data-activities-container]',
      list: '[data-activities-list]',
    };
    this._activitiesDataProperties = {

    };
  }
  $onChanges({ loading, loadingActivities }) {
    if (
      (loading && !loading.currentValue) ||
      (loadingActivities && !loadingActivities.currentValue)
    ) {
      this._loadElements();
    }
  }
  handleHeaderAction(action) {
    this.onHeaderActionClicked({ action });
  }
  infiniteScrollAction() {
    this.onInfiniteScroll();
    this.$timeout(() => {
      if (this._elements.list && this._elements.scroller) {
        this._elements.scroller.scrollTop = this._elements.list.offsetHeight;
      }
    });
  }
  openActivity($event, activity) {
    this.onActivityClick({
      $event,
      activity,
    });
  }
  _loadElements() {
    Object.keys(this._elementQueries).forEach((refName) => {
      this._elements[refName] = this.$element.querySelector(this._elementQueries[refName]);
    });
  }
  _changeDates(dates) {
    if (dates.length > 1) {
      const [startDate, endDate] = dates;
      let changes = false;
      if (startDate !== this.startDate) {
        this.startDate = startDate;
        changes = true;
      }

      if (endDate !== this.endDate) {
        this.endDate = endDate;
        changes = true;
      }

      if (changes) {
        this.onDatesChange({
          startDate: this.startDate,
          endDate: this.endDate,
        });
      }
    }
  }
}

export default {
  controller: UsersActivitiesController,
  template,
  bindings: {
    user: '<',
    activities: '<',
    loading: '<',
    loadingActivities: '<',
    loadingMoreActivities: '<',
    headerActions: '<',
    subMenu: '<',
    disableFilters: '<',
    infiniteScrollEnabled: '<',
    onHeaderActionClicked: '&',
    onDatesChange: '&',
    onInfiniteScroll: '&',
    onActivityClick: '&',
  },
};
